document.querySelector('.shinseikigoods')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods2')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul2').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods3')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul3').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods4')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul4').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods5')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul5').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods6')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul6').classList.toggle('is-opendinos');
  });
